/**
 * @file   src\mobile\components\Common\HeaderMenu.js
 * @brief  This file is responsible for heade section in home page
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React from "react";
import { pageURLs } from "@/constants";
import { useNavigate } from "react-router-dom";
import Logo from "../../../components/Common/Logo";
import { getLocalStorage, getUserType } from "../../../helpers/common";
import { USER_INFO_KEY, USER_TYPE_AGENT } from "../../../constants/common";
import { useSelector } from "react-redux";
import MessageMenu from "../../components/messageMenu";
import { useUserDetails } from "@/contextApi";

const HeaderMenu = (props) => {
  const { setSearchView, isFrom, redirectToHomePage } = props;

  let { unreadInappNotificationCount } = useSelector(
    (state) => state.unreadCount,
  );
  unreadInappNotificationCount = unreadInappNotificationCount?.payload;
  const { messageCount } = useSelector((state) => state.unreadCount);

  const navigate = useNavigate();
  const userDetails = getLocalStorage(USER_INFO_KEY);
  let userName = _.get(userDetails, "userInfo.name", null);
  let profileImage = _.get(userDetails, "userInfo.image", null);
  const userType = getUserType();

  const { shouldToggleColor, isPremiumUser } = useUserDetails();

  if (userName) {
    userName = userName.replace(/-/g, "").match(/\b(\w)/g);
  }
  return (
    <>
      {/* <div className="p-0 toplinks-mobile top-three-equal-width">
            <div
              className={`topbar-links message-icon-header ${isPremiumUser ? 'message-icon-header-premium' : ''} position-relative`}
              onClick={(e) => {
                navigate(pageURLs.mobileMessages);
                e.stopPropagation();
              }}
            >
              <MessageMenu unReadChatMessagesCount={messageCount} />
            </div>
          </div> */}
      <div
        className="p-0 logo-wrap text-center"
        role="button"
        style={{ cursor: "pointer" }}
        onClick={() => {
          navigate(pageURLs.mobileHome);
          if (isFrom == "Home") {
            setSearchView(false);
            redirectToHomePage();
          }
        }}
        onDoubleClick={() => {
          if (isFrom == "Home" && props.onLogoDoubleClick) {
            props.onLogoDoubleClick();
          }
        }}
        onKeyDown={() => {
          navigate(pageURLs.mobileHome);
          if (isFrom == "Home") {
            setSearchView(false);
            redirectToHomePage();
          }
        }}
      >
        <Logo type={shouldToggleColor ? "logoWhite" : "logoV1"} />
      </div>
      <div className="p-0 toplinks-mobile text-end">
        {userName ? (
          profileImage && userType == USER_TYPE_AGENT && isPremiumUser ? (
            <>
              <figure
                className="brdr-rs-200 profile-image-figure"
                onClick={() => navigate(pageURLs.mobileSettings)}
                role="button"
              >
                <img
                  className="brdr-rs-200"
                  src={profileImage + "?" + Math.random().toString(36)}
                  alt=""
                />
              </figure>
            </>
          ) : (
            <div
              className="profile-user-info profile-bg-meroon ms-auto"
              style={{ cursor: "pointer" }}
              onClick={() => navigate(pageURLs.mobileSettings)}
              onKeyDown={() => navigate(pageURLs.mobileSettings)}
              role="button"
            >
              {userName}
            </div>
          )
        ) : (
          <div>
            <button
              variant=""
              className="btn auth-btn-small auth-btn-alternative mr-12"
              onClick={() =>
                navigate(
                  `${pageURLs.mobileSignIn}?page=LOGIN&isEmailSignup=true`,
                )
              }
            >
              Sign In
            </button>
            <button
              variant=""
              className="btn auth-btn-small"
              onClick={() => navigate(pageURLs.mobileSignIn)}
            >
              Sign Up
            </button>
          </div>
        )}
      </div>
    </>
  );
};
export default HeaderMenu;
